import { useHistory } from 'react-router-dom';
import TokenService, { type TListener } from '@services/internal/token';
import { authActionTypes } from '@store/ducks/auth';
import React from 'react';
import { useAppDispatch } from './redux';
import { memberApiV2 } from '@lib/api';
import { actions as authActions } from '@store/ducks/auth';
import { actions as xmppActions } from '@store/ducks/xmpp';

/**
 * Subscribe to token service to token change event,
 */
function useTokensResolver(isReady: boolean) {
  const dispatch = useAppDispatch();
  const history = useHistory();
  const [tokensId, setTokensId] = React.useState(0);

  /**
   * Listener for session change
   */
  const _listener = React.useCallback<TListener>((session) => {
    if (!session) {
      history.replace('/login');
      memberApiV2.removeGlobals();

      dispatch({
        type: authActionTypes.GET_LOGIN_SUCCESS,
        payload: false,
      });

      dispatch({
        type: authActionTypes.SET_LOADING,
        payload: false,
      });
      dispatch(xmppActions.disconnectRequest());
    }

    setTokensId((o) => o + 1);
  }, []);

  /**
   * Init app from async storage
   */
  React.useEffect(() => {
    if (!isReady) {
      return;
    }

    const removeListener = TokenService.addEventListener(_listener);

    return () => {
      if (removeListener) {
        removeListener();
      }
    };
  }, [isReady]);

  React.useEffect(() => {
    dispatch(authActions.getTryLoginRequest());
  }, [dispatch, tokensId]);
}

export default useTokensResolver;
